<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner">
      <h2 class="rew19_second_title">나의 에이지락 미 리워드 철회</h2>
      <h3 class="rew19_third_title">신용카드 사용동의</h3>
      <div class="rew19_termwrap reaction">
        <div v-html="cardUseTerm" class="rew19_termbox">
          
        </div>
        <div class="rew19_wrapCheck_t1">
          <input 
            v-model="cardTermAgree"
            ref="cardTermAgree"
            type="checkbox" id="term01" class="rew19_fakeCheck_t1" />
          <label for="term01">신용카드 사용에 동의합니다</label>
        </div>
      </div>
      <h3 class="rew19_third_title insub">
        신용카드 정보
        <span class="sub_addition">신용카드의 카드번호와 유효기간을 확인하시기 바랍니다.</span>
      </h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>카드번호</em>
          <span class="substance">{{viewData.pd_detail.print_cardnumber}}</span>
        </li>
        <li class="type1">
          <em>유효기간</em>
          <span class="substance">{{viewData.pd_detail.cardExpYear}}년 {{viewData.pd_detail.cardExpMonth}}월</span>
        </li>
      </ul>
      <ul class="rew19_dotList gepTaye1">
        <li>사용불가 카드 : 외국계 카드, 법인카드</li>
        <li>결제를 위해 신용카드 정보를 입력한 후 정기구매 철회를 진행하세요.</li>
      </ul>

      <div class="rew19_responsive_btns gepTaye1">
        <a @click="onClickCancel" class="rew19-btn-border">취소</a>
        <a @click="onClickWithdraw" class="rew19-btn-normal">철회하기</a>
      </div>
    </div>
    <!--rew19_contents_inner-->
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import * as Crypto from '@/utils/cryptoUtil';

export default {
  name: "WithdrawCard",
  extends: AroBase,
  components: { }, 
  props:{
    adr_no: {
      type: String,
      required: true
    },
    memberId: {
      type: String,
      required: true
    },    
  },
  data() { 
    return {     
      //View Data 
      viewData : {
        mileage : {},
        pd_detail: {}
      },
      
      cardUseTerm : "",
      cardTermAgree : false
    }
  },
  created() {
  },
  mounted() {
    let _this = this;

    _this.$http.get(_this.$aroApiBasePath + Const.VALUE_AGG_LOC_ME_CARD_USE_TERM_CANCEL).then(res=>{
      _this.cardUseTerm = res.data;
    });
  },
  methods: {    
    /**
     * JQuery UI
     */
    initUI(){
      
    },

    /**
     * Local function
     */
    initData(paramData){
      let _this = this;

      _this.viewData = {
        ...paramData
      };

      let cardexpdate = _this.viewData.pd_detail.cardexpdate;
      let replaceCardExpDate = Crypto.replaceStringForTextIntegration(cardexpdate, _this.viewData.pd_detail, _this.memberId);
      if(replaceCardExpDate && replaceCardExpDate.length == 4){
        let cardExpYear = replaceCardExpDate.substring(0, 2);
        let cardExpMonth = replaceCardExpDate.substring(2);
        _this.viewData.pd_detail.cardExpYear = cardExpYear;
        _this.viewData.pd_detail.cardExpMonth = cardExpMonth;
      }		  
    },

    //취소
    onClickCancel(){
      this.$emit('cancel');
    },

    //철회 하기
    onClickWithdraw(){
      let _this = this;

      if(!_this.cardTermAgree){        
        _this.$dialogs.alert("신용카드 사용에 동의해 주세요.")
          .then(res => {
            _this.$refs.cardTermAgree.focus();
          });
        return;
      }

      _this.$emit('doWithdraw', _this.AroConst.VALUE_payment_type_credit_card, {});
    }
  }
}
</script>
<style>
a.rew19-btn-border, a.rew19-btn-normal{
  cursor: pointer;
}

ul.num {
  margin-inline-start:20px;
}

ul.num li{
  list-style-type: decimal;
}
</style>


// WEBPACK FOOTER //
// src/views/my/ageloc/withdrawCard.vue